import React from 'react'
import "./Home.css"

export default function Home() {
  return (
    <div  className='mainHome'>
     
    <div  className='homecss'>

      <h1 className="heding1">Hi,I  am  Kailash  Chandra</h1>
     <h1 className="headingrole">I Am Full Stack Developer</h1>
     <p className="pargrapfh">An enthusiastic web developer with strong technical  skills and expertise  in MERN stack
     </p>
     <a href='./Kailash_Chandra_Resume.pdf'  download 
      >
     <button className='btn1' onClick={()=>window.open("https://drive.google.com/file/d/1ZLwfIroggXPMbYEVkA2_fJhRktRRCC-y/view?usp=sharing")}>Resume</button>

     </a>
    </div>

    <div className='image'>

         <div className='imgcss'>
            <img src="kailash3.jpg"
             alt="kailash"/>
         </div>
    </div>

      
    </div>
  )
}
